import {tns} from 'tiny-slider';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { dataLayerEvents } from './dataLayerEvents';
import animations from  './utils/animations';

const mq = window.matchMedia('(max-width: 740px)');
const mqMedium = window.matchMedia( '(min-width:740px) and (max-width: 980px)' );
const isTablet = mqMedium.matches;
let isMobile = mq.matches;
let desktopSlider;
let mobileSwiper;

window.addEventListener('resize', () => {
    isMobile = mq.matches;

    if (!isMobile) {
        desktopSlider && desktopSlider.destroy && desktopSlider.destroy();
        homePageBuilder();
    }
}, );

const addStyleLastSlide = (info) => {
    const $slideItems = $(info.slideItems);
    const $nextButton = $(info.nextButton);
    const $activeSlides = $slideItems.closest('.tns-slide-active');
    // if we see all slides in one screen
    if ($activeSlides?.length === info.slideCount) return;

    $slideItems.removeClass('m_last-active');

    $activeSlides.last().addClass('m_last-active');

    if ($nextButton.css('display') === 'none') {
        $slideItems.removeClass('m_last-active');
    }

    setTimeout(() => {
        if ($(info.controlsContainer).css('display') === 'none') {
            $slideItems.removeClass('m_last-active');
        }

        if ($slideItems.last().hasClass('tns-slide-active') && $nextButton.css('display') !== 'none') {
            $slideItems.removeClass('m_last-active');
            $slideItems.last().addClass('m_last-active');
        }
    }, 5)
}

function sliderInitialization(id, {mobile = {}, desktop = {}, params={}, slidesPerView = 1, isControl = true, spaceBetween = 0}) {
    const $sliderContainer = $(`.index-${id}`);
    const sliderSelector = `.js_slider-id-${id}`;
    const controlsContainer = `${sliderSelector}-controls`;

    if (isMobile || isTablet) {
        if ($sliderContainer.hasClass('is-initialized') || !$(`.js_swiper-id-${id}`).length) return;

        mobileSwiper = new Swiper(`.js_swiper-id-${id}`, {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            slidesPerView,
            spaceBetween,
            freeMode: true,
            cssMode: true,
            navigation: isControl ? {
                nextEl: `${controlsContainer} .slider-controls__next`,
                prevEl: `${controlsContainer} .slider-controls__prev`,
            } : {},
        });

        $sliderContainer.addClass('is-initialized');
    } else {
        if (!$(sliderSelector).hasClass('js_slider-unique-line') && !$(sliderSelector).hasClass('js_slider-from-ajax')) return;

        const defaultParams = {
            container: sliderSelector,
            speed: 400,
            loop: false,
            mouseDrag: false,
            gutter: 30
        };

        const onInit = (info) => {
            const $activeSlides = $(info.slideItems).closest('.tns-slide-active');
            addStyleLastSlide(info);

            if ($activeSlides?.length ===  info.slideCount + 1 ) {
                $(controlsContainer).hide();
            }

            info.controlsContainer.tabIndex = -1; // Remove keyboard focus from controls (each slide is focusable)
        };
        const initObject = {...desktop, ...params, ...defaultParams, controlsContainer, onInit };
        desktopSlider = tns(initObject);

        desktopSlider.events.on('indexChanged', addStyleLastSlide);
    }
}

const redirectToNewPage = (isNewTab, url) => {
    if (isNewTab) {
        window.open(url, '_blank').focus();
    } else {
        window.location.href = url;
    }
}

const attachAnalyticsClickEvent = () => {
    $('.js_banner-block').off().on('click', async event => {
        const $currentTarget = $(event.currentTarget);
        const { link, contentid, isnewtab } = $currentTarget.data();
        const title = $currentTarget.find('.js_title').text();

        try {
            await dataLayerEvents.selectContent({
                content_type: title,
                content_id: contentid,
            });
        } catch(e) {
            console.log(e);
        }

        redirectToNewPage(isnewtab, link);
    });

    $('.js_blog-block').each((index, item) => {
        const $item = $(item);

        $item.off().on('click', async event => {
            const $currentTarget = $(event.currentTarget);
            const title = $currentTarget.find('.js_title').text();
            const { link, isnewtab } = $currentTarget.data();

            try {
                await dataLayerEvents.selectPromotion({
                    promotion_id: 'blog',
                    promotion_name: title,
                });
            } catch(e) {
                console.log(e);
            }

            redirectToNewPage(isnewtab, link);
        })
    });
}

const uniqueSlider = (selector) => {
    const uniqueIdArray = [];

    $(selector).each( (i, slider) => {
        const sliderClasses = slider.classList.value;
        const uniqueId = sliderClasses.slice(sliderClasses.lastIndexOf('-') + 1);
        uniqueIdArray.push(uniqueId);
    });
    return uniqueIdArray;
};

export function homePageBuilder() {
    let widthSlide;
    const clientWidth = document.documentElement.clientWidth;

    const separationArraySlider = uniqueSlider('.js_separationLine-slider');

    // Temporary fix to prevent issue with slide indexes after swiping and clicking on arrows
    if (isMobile || isTablet) {
        $('.js_slider-container').find('.m_desktop').remove();
    }

    if (separationArraySlider && separationArraySlider.length) {

        separationArraySlider.forEach(sliderId => {
            if ( $(`.js_slider-id-${sliderId}`)?.children()?.length) {
                if ( isMobile) {
                    tns({
                        container: `.js_slider-id-${sliderId}`,
                        loop: true,
                        autoplay: true,
                        nav: false,
                        controls: false,
                        autoplayButton: false,
                        autoplayButtonOutput: false,
                        items: 1
                    });
                }
            }
        })
    }

    animations.bannersSlider();

    // CTA slider
    const ctaArraySlider = uniqueSlider('.js_CTA_block-slider');

    if (ctaArraySlider && ctaArraySlider.length) {

        ctaArraySlider.forEach(sliderId => {
            sliderInitialization(sliderId, {
                desktop: {
                    fixedWidth: 255,
                },
                slidesPerView: isMobile ? 1.6 : 1,
                isControl: false,
                spaceBetween: 30,
            });
        })
    }

    // CTA slider
    const smallCtaArraySlider = uniqueSlider('.js_small_block-slider');

    if (smallCtaArraySlider && smallCtaArraySlider.length) {

        smallCtaArraySlider.forEach(sliderId => {
            sliderInitialization(sliderId, {
                desktop: {
                    fixedWidth: 160,
                }
            });
        })
    }

    if (clientWidth < 350) {
        widthSlide = 160;
    } else if ( clientWidth < 480 ) {
        widthSlide = 214;
    } else if ( clientWidth < 768 ) {
        widthSlide = 248;
    } else {
        widthSlide = 285;
    }

    // product slider
    const productArraySlider = uniqueSlider('.js_product_block-slider');

    if (productArraySlider && productArraySlider.length) {

        productArraySlider.forEach(sliderId => {
            sliderInitialization(sliderId, {
                mobile: {
                    gutter: 0,
                },
                params: {
                    fixedWidth: widthSlide,
                },
                slidesPerView: 2
            });
        })
    }

    attachAnalyticsClickEvent();
}
